import React from 'react';
import {
  Container, Row, Col, Button,
  Card, CardBody, CardTitle
} from 'reactstrap';

import useConfigState from './useConfigState.js';
import GeneralesConfig from './GeneralesConfig.js';
import FiltrosConfig from './FiltrosConfig.js';
import VisitantesConfig from './VisitantesConfig.js';
import PedidosConfig from './PedidosConfig.js';

import './styles.css';
import StockConfig from './StockConfig.js';
import OrdenamientosConfig from './OrdenamientosConfig.js';

const Configuracion = () => {

  const { state, setState, save } = useConfigState();

  return (
    <React.Fragment>
      <Container fluid className="ConfiguracionContainer p-0">
        <Card className="mb-1">
          <CardTitle className="text-center" tag="h1">Configuración de Sitio</CardTitle>
          <CardBody>
            <div className="bg-primary w-100 text-center"><h2>Generales</h2></div>
            <GeneralesConfig {...{ state, setState }} />
            <Row className="my-1">
              <Col xs={12} xl={4} className="p-1">
                <div className="bg-primary w-100 text-center"><h2>Filtros de Artículos</h2></div>
                <FiltrosConfig {...{ state, setState }} />
                <div className="bg-primary w-100 text-center"><h2>Ordenamientos</h2></div>
                <OrdenamientosConfig {...{ state, setState }} />
                <div className="bg-primary w-100 text-center"><h2>Depositos y Stock</h2></div>
                <StockConfig {...{ state, setState }} />
              </Col>
              <Col xs={12} xl={4} className="p-1">
                <div className="bg-primary w-100 text-center"><h2>Visitantes</h2></div>
                <VisitantesConfig {...{ state, setState }} />
              </Col>
              <Col xs={12} xl={4} className="p-1">
                <div className="bg-primary w-100 text-center"><h2>Pedidos</h2></div>
                <PedidosConfig {...{ state, setState }} />
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Button color="success" className="mx-auto d-block" onClick={() => save(state)}><i className="fa fa-check-circle" aria-hidden="true"></i> Guardar Cambios</Button>
      </Container>
    </React.Fragment>
  )
}

export default Configuracion;



// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/Configuracion.js